import { render, staticRenderFns } from "./tickling.vue?vue&type=template&id=4771b3ce&scoped=true&"
import script from "./tickling.vue?vue&type=script&lang=js&"
export * from "./tickling.vue?vue&type=script&lang=js&"
import style0 from "./tickling.vue?vue&type=style&index=0&id=4771b3ce&lang=scss&scoped=true&"
import style1 from "./tickling.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771b3ce",
  null
  
)

export default component.exports